import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";

import { IVerifyOTPRequest } from "../../../types";
import { GeneralResponse } from "../../../types/api";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";

export const VerifyOTP = async (
  payload: IVerifyOTPRequest
): Promise<GeneralResponse> => {
  try {
    const response = await Api<any, GeneralResponse<IVerifyOTPRequest>>({
      method: Methods.POST,
      endpoint: EndPoints.verifyOTP,
      body: payload,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useVerifyOTP = (options = {}) => {
  const mutation: UseMutationResult<GeneralResponse, Error, IVerifyOTPRequest> =
    useMutation({
      mutationFn: VerifyOTP,
      ...options,
    });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
